export const availableWeekdays = [
  {
    name: 'Pirmadieniais',
    value: 1,
  },
  {
    name: 'Antradieniais',
    value: 2,
  },
  {
    name: 'Trečiadieniais',
    value: 3,
  },
  {
    name: 'Ketvirtadieniais',
    value: 4,
  },
  {
    name: 'Penktadieniais',
    value: 5,
  },
  {
    name: 'Šeštadieniais',
    value: 6,
  },
  {
    name: 'Sekmadieniais',
    value: 0,
  },
];

export const discountUsageTypes = [
  {
    name: 'Vienkartinis',
    value: 191,
  },
  {
    name: 'Daugkartinis',
    value: 192,
  },
];

export const ALL_SERVICES_VALUE = 'all-services';

export const bannerPlacementOptions = [
  {
    name: 'Akcijos',
    value: 'deals',
  },
  {
    name: 'Pagrindinis puslapis',
    value: 'home',
  },
  {
    name: 'Meniu',
    value: 'menu',
    disabled: true,
  },
  {
    name: 'Apmokėjimuose',
    value: 'payments',
    disabled: true,
  },
];
